/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

// import React from 'react';
import {createRoot} from 'react-dom/client';

import {App} from './App';
import './styles/global.css';
import './styles/legacy-global.css';
import {Providers} from './providers/Providers';

createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <Providers>
    <App />
  </Providers>,
  // </React.StrictMode>,
);
